import { useEffect, useState } from "react";
import Select, { components } from "react-select";
import CustomTable from "../../Components/CustomTable";
import AddEditCommittee from "./AddEditCommittee";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  committeeList,
  committeeChangeStatus,
  getDesignationList,
  deleteCommittee,
  committeeExport,
  // getDistrictList,
  // getTalukaList,
  // getVillageList,
} from "../../Redux/Slices/committeeSlice";
import { FiTrash2 } from "react-icons/fi";
import DeleteModal from "../../Components/DeleteModal";

// Checkbox option for react-select
// const CheckboxOption = (props) => (
//   <components.Option {...props} className="flex items-center">
//     <input
//       type="checkbox"
//       checked={props.isSelected}
//       onChange={() => null}
//       className="mr-2"
//     />
//     <span>{props.label}</span>
//   </components.Option>
// );

// MenuList with "Select All" checkbox
// const CheckboxMenuList = (props) => {
//   const { options, value, onChange } = props.selectProps;
//   const isAllSelected = options?.length && value?.length === options.length;

//   const toggleSelectAll = () => {
//     if (isAllSelected) {
//       onChange([], { action: "deselect-option" });
//     } else {
//       onChange(options, { action: "select-option" });
//     }
//   };

//   return (
//     <>
//       <div
//         className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100 border-b"
//         onClick={toggleSelectAll}
//       >
//         <input
//           type="checkbox"
//           readOnly
//           className="mr-2"
//           checked={isAllSelected}
//           onChange={() => null}
//         />
//         <span>Select All</span>
//       </div>
//       <components.MenuList {...props}>{props.children}</components.MenuList>
//     </>
//   );
// };

const Committee = () => {
  // const checkboxComponents = {
  //   Option: CheckboxOption,
  //   MenuList: CheckboxMenuList,
  // };
  const menuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [paginationState, setPaginationState] = useState({
    page: 1,
    limit: 10,
  });
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [designations, setDesignations] = useState([]);
  // const [SelectedVillage, setSelectedVillage] = useState([]);
  // const [SelectedTaluka, setSelectedTaluka] = useState([]);
  // const [SelectedDistrict, setSelectedDistrict] = useState([]);
  // const [villages, setVillages] = useState([]);
  // const [talukas, setTalukas] = useState([]);
  // const [districts, setDistricts] = useState([]);

  const getDesignation = async () => {
    try {
      const response = await dispatch(getDesignationList()).unwrap();
      if (response.IsSuccess) {
        setDesignations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch designations");
    }
  };

  // const fetchTalukas = async (districtId) => {
  //   try {
  //     const response = await dispatch(getTalukaList({ districtId })).unwrap();
  //     if (response.IsSuccess) {
  //       const filtered =
  //         response.Data?.filter((t) => t.districtId?._id === districtId) || [];
  //       setTalukas((prev) => {
  //         const merged = [...prev, ...filtered];
  //         return merged.filter(
  //           (t, i, self) => self.findIndex((x) => x._id === t._id) === i,
  //         );
  //       });
  //     }
  //   } catch (error) {
  //     toast.error("Failed to fetch Talukas");
  //   }
  // };

  // const fetchVillages = async (talukaId) => {
  //   try {
  //     const response = await dispatch(getVillageList({ talukaId })).unwrap();
  //     if (response.IsSuccess) {
  //       const filtered =
  //         response.Data?.filter((v) => v.talukaId?._id === talukaId) || [];
  //       setVillages((prev) => {
  //         const merged = [...prev, ...filtered];
  //         return merged.filter(
  //           (v, i, self) => self.findIndex((x) => x._id === v._id) === i,
  //         );
  //       });
  //     }
  //   } catch (error) {
  //     toast.error("Failed to fetch Villages");
  //   }
  // };

  // const getDistrict = async () => {
  //   try {
  //     const response = await dispatch(getDistrictList()).unwrap();
  //     if (response.IsSuccess) {
  //       setDistricts(response.Data || []);
  //     }
  //   } catch (error) {
  //     toast.error("Failed to fetch Districts");
  //   }
  // };

  const handleClearFilter = () => {
    setSearchValue("");
    // setSelectedVillage([]);
    // setSelectedTaluka([]);
    // setSelectedDistrict([]);
    setSelectedDesignation("");
  };

  const handleOpenDialog = (row) => {
    setIsDialogOpen(true);
    setSelectedRowData(row);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedRowData(null);
    getCommitteeListFun();
  };

  const handleDeleteClick = (id) => {
    setIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await dispatch(
        deleteCommittee({ committeeMemberId: idToDelete }),
      ).unwrap();
      if (response?.IsSuccess) {
        toast.success(response?.Message || "Member deleted successfully");
        getCommitteeListFun();
      }
    } catch (error) {
      toast.error("Failed to delete member");
    } finally {
      setIsDeleteModalOpen(false);
      setIdToDelete(null);
    }
  };

  const handleStatusChange = async (id) => {
    try {
      const response = await dispatch(
        committeeChangeStatus({
          committeeMemberId: id,
        }),
      ).unwrap();
      if (response?.IsSuccess) {
        toast.success(response?.Message);
        getCommitteeListFun();
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const getCommitteeListFun = async () => {
    try {
      setLoading(true);
      const payload = {
        page: paginationState.page,
        limit: paginationState.limit,
        search: searchValue || "",
        designation: selectedDesignation || "",
        // district: SelectedDistrict.length
        //   ? SelectedDistrict.map((d) => d.value)
        //   : [],
        // taluka: SelectedTaluka.length ? SelectedTaluka.map((t) => t.value) : [],
        // village: SelectedVillage.length
        //   ? SelectedVillage.map((v) => v.value)
        //   : [],
      };
      const response = await dispatch(committeeList(payload)).unwrap();
      setTableData(response.Data.docs);
      setPaginationData(response.Data.totalDocs);
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportData = async () => {
    try {
      setLoading(true);
      const payload = {
        search: searchValue || "",
        designation: selectedDesignation || "",
      };
      const response = await dispatch(committeeExport(payload)).unwrap();
      if (response?.IsSuccess) {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = response.Data;
        a.target = "_self";
        a.download = response.Data;
        a.click();
        window.URL.revokeObjectURL(response.Data);
        a.remove();
        toast.success("Data exported successfully");
        setLoading(false);
        getCommitteeListFun();
      }
    } catch (error) {
      toast.error("Failed to export data");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (page, limit) => {
    setLoading(true);
    try {
      const payload = {
        page: page || 1,
        limit: limit || 10,
        search: searchValue || "",
        designation: selectedDesignation || "",
        // district: SelectedDistrict.length
        //   ? SelectedDistrict.map((d) => d.value)
        //   : [],
        // taluka: SelectedTaluka.length ? SelectedTaluka.map((t) => t.value) : [],
        // village: SelectedVillage.length
        //   ? SelectedVillage.map((v) => v.value)
        //   : [],
      };
      setPaginationState({ page: page, limit: limit });
      const response = await dispatch(committeeList(payload)).unwrap();
      setTableData(response.Data.docs);
      setPaginationData(response.Data.totalDocs);
      setLoading(false);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  // Table columns configuration
  const columns = [
    {
      key: "user",
      label: "Member Name",
      renderCell: (key, row) =>
        `${row?.user?.surname} ${row?.user?.name} ${row?.user?.fathername}` ||
        "-",
    },
    {
      key: "mobileNo",
      label: "Mobile Number",
      renderCell: (key, row) =>
        `${row?.user?.countryCode} ${row?.user?.mobile}` || "-",
    },
    {
      key: "designation",
      label: "Designation",
      renderCell: (key, row) => row?.designation?.gujarati_name || "-",
    },
    {
      key: "district",
      label: "District",
      renderCell: (key, row) => row?.district?.gujarati_name || "-",
    },
    {
      key: "taluka",
      label: "Taluka",
      renderCell: (key, row) => row?.taluka?.gujarati_name || "-",
    },
    {
      key: "village",
      label: "Village",
      renderCell: (key, row) => row?.village?.gujarati_name || "-",
    },
    {
      key: "status",
      label: "Status",
      renderCell: (key, row) => (
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={row?.status}
            onChange={() => handleStatusChange(row?._id)}
          />
          <div
            // onChange={() => handleStatusChange(row?._id)}
            className={`
                        relative w-9 h-5 lg:w-11 lg:h-6 
                        bg-gray-200 
                        peer-focus:outline-none 
                        rounded-full 
                        peer 
                        peer-checked:after:translate-x-full 
                        peer-checked:after:border-white 
                        after:content-[''] 
                        after:absolute 
                        after:top-[2px] 
                        after:left-[2px]
                        after:bg-white 
                        after:border-gray-300 
                        after:border 
                        after:rounded-full 
                        lg:after:h-5 
                        lg:after:w-5 
                        after:h-4 
                        after:w-4 
                        after:transition-all
                        peer-checked:bg-blue-600
                    `}
          ></div>
        </label>
      ),
    },
    {
      key: "action",
      label: "Action",
      renderCell: (key, row) => (
        <div className="flex items-center justify-center gap-2">
          <span
            className="flex-shrink-0 group cursor-pointer"
            onClick={() => handleOpenDialog(row)}
          >
            <svg
              className="w-5 h-5 fill-gray_2 group-hover:fill-green transition-color anim"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.06107 20.2164L4.50191 19.6096H4.50191L4.06107 20.2164ZM2.95491 19.1102L2.34815 19.5511L2.34815 19.5511L2.95491 19.1102ZM17.9389 20.2164L17.4981 19.6096H17.4981L17.9389 20.2164ZM19.0451 19.1102L18.4383 18.6694L19.0451 19.1102ZM2.95491 5.23238L2.34815 4.79155L2.34815 4.79155L2.95491 5.23238ZM4.06107 4.12623L4.50191 4.73299V4.73299L4.06107 4.12623ZM9.00899 3.92846C9.42317 3.9235 9.75491 3.58371 9.74995 3.16953C9.74498 2.75534 9.40519 2.42361 8.99101 2.42857L9.00899 3.92846ZM20.7427 14.1803C20.7477 13.7661 20.416 13.4263 20.0018 13.4214C19.5876 13.4164 19.2478 13.7481 19.2428 14.1623L20.7427 14.1803ZM11.7976 16.1758L11.7147 15.4303L11.7976 16.1758ZM7.67777 15.8783L7.14744 16.4086L7.14744 16.4086L7.67777 15.8783ZM7.3803 11.7585L8.12571 11.8413L7.3803 11.7585ZM8.5274 9.3718L7.99707 8.84147L8.5274 9.3718ZM7.64293 10.4157L6.96696 10.0908L6.96695 10.0908L7.64293 10.4157ZM14.1843 15.0287L14.7146 15.559L14.1843 15.0287ZM13.1403 15.9131L13.4652 16.5891H13.4652L13.1403 15.9131ZM11 20.4213C9.10843 20.4213 7.74999 20.4203 6.69804 20.3063C5.66013 20.1939 5.00992 19.9787 4.50191 19.6096L3.62024 20.8232C4.42656 21.409 5.37094 21.6713 6.53648 21.7976C7.68798 21.9223 9.14184 21.9213 11 21.9213V20.4213ZM1.25 12.1713C1.25 14.0295 1.24897 15.4833 1.37373 16.6348C1.50001 17.8004 1.76232 18.7448 2.34815 19.5511L3.56168 18.6694C3.19259 18.1614 2.97745 17.5112 2.865 16.4733C2.75103 15.4213 2.75 14.0629 2.75 12.1713H1.25ZM4.50191 19.6096C4.14111 19.3475 3.82382 19.0302 3.56168 18.6694L2.34815 19.5511C2.70281 20.0392 3.13209 20.4685 3.62024 20.8232L4.50191 19.6096ZM11 21.9213C12.8582 21.9213 14.312 21.9223 15.4635 21.7976C16.6291 21.6713 17.5734 21.409 18.3798 20.8232L17.4981 19.6096C16.9901 19.9787 16.3399 20.1939 15.302 20.3063C14.25 20.4203 12.8916 20.4213 11 20.4213V21.9213ZM18.4383 18.6694C18.1762 19.0302 17.8589 19.3475 17.4981 19.6096L18.3798 20.8232C18.8679 20.4685 19.2972 20.0392 19.6518 19.5511L18.4383 18.6694ZM2.75 12.1713C2.75 10.2797 2.75103 8.9213 2.865 7.86936C2.97745 6.83144 3.19259 6.18123 3.56168 5.67322L2.34815 4.79155C1.76232 5.59787 1.50001 6.54225 1.37373 7.70779C1.24897 8.85929 1.25 10.3132 1.25 12.1713H2.75ZM3.62023 3.51946C3.13209 3.87412 2.70281 4.3034 2.34815 4.79155L3.56168 5.67322C3.82382 5.31242 4.14111 4.99513 4.50191 4.73299L3.62023 3.51946ZM8.99101 2.42857C6.56449 2.45766 4.89894 2.59043 3.62023 3.51946L4.50191 4.73299C5.33627 4.1268 6.50819 3.95844 9.00899 3.92846L8.99101 2.42857ZM19.2428 14.1623C19.2129 16.6631 19.0445 17.835 18.4383 18.6694L19.6518 19.5511C20.5809 18.2724 20.7137 16.6068 20.7427 14.1803L19.2428 14.1623ZM19.0257 9.12652L13.6539 14.4983L14.7146 15.559L20.0864 10.1872L19.0257 9.12652ZM9.05773 9.90213L14.4295 4.53033L13.3689 3.46967L7.99707 8.84147L9.05773 9.90213ZM11.7147 15.4303C10.5448 15.5603 9.74843 15.647 9.15674 15.6279C8.58517 15.6094 8.35441 15.4943 8.2081 15.348L7.14744 16.4086C7.68084 16.942 8.36328 17.103 9.10833 17.1271C9.83326 17.1505 10.757 17.046 11.8804 16.9212L11.7147 15.4303ZM6.63488 11.6757C6.51006 12.7991 6.40557 13.7228 6.42898 14.4477C6.45304 15.1928 6.61405 15.8752 7.14744 16.4086L8.2081 15.348C8.06179 15.2016 7.94665 14.9709 7.9282 14.3993C7.90909 13.8076 7.99571 13.0113 8.12571 11.8413L6.63488 11.6757ZM7.99707 8.84147C7.54195 9.2966 7.18261 9.64213 6.96696 10.0908L8.31891 10.7406C8.39835 10.5753 8.53029 10.4296 9.05773 9.90213L7.99707 8.84147ZM8.12571 11.8413C8.20808 11.1 8.23947 10.9059 8.31891 10.7406L6.96695 10.0908C6.7513 10.5395 6.70596 11.036 6.63488 11.6757L8.12571 11.8413ZM13.6539 14.4983C13.1265 15.0258 12.9807 15.1577 12.8155 15.2372L13.4652 16.5891C13.9139 16.3734 14.2595 16.0141 14.7146 15.559L13.6539 14.4983ZM11.8804 16.9212C12.5201 16.8501 13.0165 16.8048 13.4652 16.5891L12.8155 15.2372C12.6502 15.3166 12.4561 15.348 11.7147 15.4303L11.8804 16.9212ZM19.0257 4.53033C19.7074 5.21199 20.1642 5.67101 20.4598 6.05849C20.7422 6.42866 20.8061 6.64413 20.8061 6.82843H22.3061C22.3061 6.1843 22.0366 5.65222 21.6523 5.14862C21.2813 4.66232 20.7381 4.12134 20.0864 3.46967L19.0257 4.53033ZM20.0864 10.1872C20.7381 9.53551 21.2813 8.99453 21.6523 8.50824C22.0366 8.00463 22.3061 7.47256 22.3061 6.82843H20.8061C20.8061 7.01272 20.7422 7.22819 20.4598 7.59836C20.1642 7.98584 19.7074 8.44486 19.0257 9.12652L20.0864 10.1872ZM20.0864 3.46967C19.4347 2.818 18.8937 2.27476 18.4074 1.90373C17.9038 1.5195 17.3718 1.25 16.7276 1.25V2.75C16.9119 2.75 17.1274 2.81383 17.4976 3.09627C17.8851 3.3919 18.3441 3.84867 19.0257 4.53033L20.0864 3.46967ZM14.4295 4.53033C15.1112 3.84867 15.5702 3.3919 15.9577 3.09627C16.3279 2.81383 16.5433 2.75 16.7276 2.75V1.25C16.0835 1.25 15.5514 1.5195 15.0478 1.90373C14.5615 2.27476 14.0206 2.818 13.3689 3.46967L14.4295 4.53033ZM20.0864 9.12652L14.4295 3.46967L13.3689 4.53033L19.0257 10.1872L20.0864 9.12652Z"

              />
            </svg>
          </span>
          <span
            className="flex-shrink-0 group cursor-pointer"
            onClick={() => handleDeleteClick(row?._id)}
          >
            <FiTrash2 className="w-5 h-5 text-gray_2 group-hover:text-red transition-color anim" />
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getCommitteeListFun();
    getDesignation();
    // getDistrict();
    // if (SelectedDistrict.length) {
    //   SelectedDistrict.forEach((d) => fetchTalukas(d.value));
    // }
    // if (SelectedTaluka.length) {
    //   SelectedTaluka.forEach((t) => fetchVillages(t.value));
    // }
  }, [
    searchValue,
    selectedDesignation,
    // SelectedDistrict,
    // SelectedTaluka,
    // SelectedVillage,
  ]);

  useEffect(() => {
    getCommitteeListFun();
  }, [paginationState.page, paginationState.limit]);

  return (
    <>
      <div className="p-5 md:p-6 lg:p-7 2xl:p-9 h-full">
        <div className="flex flex-col h-full">
          {/* Filter Section */}
          <div className="w-full">
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="flex flex-wrap items-center gap-4 ml-auto">

                <div className="w-full md:w-auto relative">
                  <span className="absolute left-3 top-3 cursor-pointer">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1_405)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.33398 0.167969C3.74413 0.167969 0.833984 3.07812 0.833984 6.66797C0.833984 10.2578 3.74413 13.168 7.33398 13.168C10.9238 13.168 13.834 10.2578 13.834 6.66797C13.834 3.07812 10.9238 0.167969 7.33398 0.167969ZM1.83398 6.66797C1.83398 3.6304 4.29642 1.16797 7.33398 1.16797C10.3716 1.16797 12.834 3.6304 12.834 6.66797C12.834 9.70553 10.3716 12.168 7.33398 12.168C4.29642 12.168 1.83398 9.70553 1.83398 6.66797Z"
                          fill="#AFBACA"
                        />
                        <path
                          d="M13.0209 11.6478C12.8257 11.4525 12.5091 11.4525 12.3138 11.6478C12.1185 11.8431 12.1185 12.1597 12.3138 12.3549L14.9804 15.0215C15.1757 15.2168 15.4922 15.2168 15.6875 15.0216C15.8828 14.8263 15.8828 14.5097 15.6875 14.3144L13.0209 11.6478Z"
                          fill="#AFBACA"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_405">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <input
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    type="text"
                    placeholder="Search"
                    className="w-full pl-10 pr-4 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                  />
                </div>

                <div className="flex flex-wrap items-center gap-4">
                  <button
                    onClick={() => handleExportData()}
                    className="w-full md:w-auto flex items-center px-4 py-2 text-14 font-medium shadow-custom_shadow bg-white border rounded-md text-text_1 hover:bg-gray-50"
                  >
                    <span className=" mr-2">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.01486 17.4487L5.89753 18.1895L5.89753 18.1895L6.01486 17.4487ZM2.5513 13.9851L3.29206 13.8678L2.5513 13.9851ZM17.4487 13.9851L18.1895 14.1025L18.1895 14.1025L17.4487 13.9851ZM13.9851 17.4487L14.1025 18.1895H14.1025L13.9851 17.4487ZM17.2666 8.71623C17.0179 8.38504 16.5477 8.31822 16.2165 8.56699C15.8853 8.81576 15.8185 9.28591 16.0673 9.6171L17.2666 8.71623ZM3.9327 9.6171C4.18147 9.28591 4.11465 8.81576 3.78346 8.56699C3.45227 8.31822 2.98212 8.38504 2.73335 8.71623L3.9327 9.6171ZM10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58579 1.75 9.25 2.08579 9.25 2.5H10.75ZM7.25435 10.3674C6.997 10.0428 6.52526 9.9883 6.2007 10.2456C5.87613 10.503 5.82163 10.9747 6.07898 11.2993L7.25435 10.3674ZM7.83154 12.3025L7.24385 12.7684L7.83154 12.3025ZM12.1685 12.3025L11.5808 11.8365L12.1685 12.3025ZM13.921 11.2993C14.1784 10.9747 14.1239 10.503 13.7993 10.2456C13.4747 9.9883 13.003 10.0428 12.7456 10.3674L13.921 11.2993ZM9.79111 14.1501L9.6731 14.8907H9.67311L9.79111 14.1501ZM10.2089 14.1501L10.3269 14.8907H10.3269L10.2089 14.1501ZM16.75 11.6667V12.5H18.25V11.6667H16.75ZM12.5 16.75H7.5V18.25H12.5V16.75ZM3.25 12.5V11.6667H1.75V12.5H3.25ZM7.5 16.75C6.69717 16.75 6.38307 16.7477 6.13218 16.7079L5.89753 18.1895C6.29441 18.2523 6.75449 18.25 7.5 18.25V16.75ZM1.75 12.5C1.75 13.2455 1.74767 13.7056 1.81053 14.1025L3.29206 13.8678C3.25233 13.6169 3.25 13.3028 3.25 12.5H1.75ZM6.13218 16.7079C4.67022 16.4764 3.52362 15.3298 3.29206 13.8678L1.81053 14.1025C2.14374 16.2063 3.79373 17.8563 5.89753 18.1895L6.13218 16.7079ZM16.75 12.5C16.75 13.3028 16.7477 13.6169 16.7079 13.8678L18.1895 14.1025C18.2523 13.7056 18.25 13.2455 18.25 12.5H16.75ZM12.5 18.25C13.2455 18.25 13.7056 18.2523 14.1025 18.1895L13.8678 16.7079C13.6169 16.7477 13.3028 16.75 12.5 16.75V18.25ZM16.7079 13.8678C16.4764 15.3298 15.3298 16.4764 13.8678 16.7079L14.1025 18.1895C16.2063 17.8563 17.8563 16.2063 18.1895 14.1025L16.7079 13.8678ZM18.25 11.6667C18.25 10.5607 17.8839 9.53804 17.2666 8.71623L16.0673 9.6171C16.4962 10.1881 16.75 10.8966 16.75 11.6667H18.25ZM3.25 11.6667C3.25 10.8966 3.50384 10.1881 3.9327 9.6171L2.73335 8.71623C2.11607 9.53804 1.75 10.5607 1.75 11.6667H3.25ZM9.25 2.5V13.3333H10.75V2.5H9.25ZM6.07898 11.2993L7.24385 12.7684L8.41922 11.8365L7.25435 10.3674L6.07898 11.2993ZM12.7561 12.7684L13.921 11.2993L12.7456 10.3674L11.5808 11.8365L12.7561 12.7684ZM7.24385 12.7684C7.69695 13.3399 8.07587 13.8196 8.41604 14.1611C8.75955 14.506 9.15655 14.8084 9.6731 14.8907L9.90912 13.4094C9.85955 13.4015 9.74124 13.366 9.47874 13.1025C9.21289 12.8356 8.89509 12.4367 8.41922 11.8365L7.24385 12.7684ZM11.5808 11.8365C11.1049 12.4367 10.7871 12.8356 10.5213 13.1025C10.2588 13.366 10.1405 13.4015 10.0909 13.4094L10.3269 14.8907C10.8435 14.8084 11.2405 14.506 11.584 14.1611C11.9241 13.8196 12.303 13.3399 12.7561 12.7684L11.5808 11.8365ZM9.67311 14.8907C9.78134 14.908 9.89057 14.9167 10 14.9167V13.4167C9.9699 13.4167 9.93959 13.4143 9.90912 13.4094L9.67311 14.8907ZM10 14.9167C10.1094 14.9167 10.2187 14.908 10.3269 14.8907L10.0909 13.4094C10.0604 13.4143 10.0301 13.4167 10 13.4167V14.9167ZM9.25 13.3333V14.1667H10.75V13.3333H9.25Z"
                          fill="#2D3643"
                        />
                      </svg>
                    </span>
                    Download Report
                  </button>
                  <select
                    value={selectedDesignation || ""}
                    onChange={(e) => setSelectedDesignation(e.target.value)}
                    className="px-5 py-2 border rounded-md bg-white text-gray_2 focus:outline-none shadow-custom_shadow"
                  >
                    <option value="">Select Designation</option>
                    {designations.map((item) => (
                      <option key={item?._id} value={item?._id}>
                        {item?.gujarati_name}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn flex justify-center items-center space-x-1"
                    onClick={() => handleOpenDialog()}
                  >
                    <span className="flex-shrink-0 group cursor-pointer">
                      <svg
                        className="group-hover:text-primary transition-colors"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0003 4.16602V15.8327M4.16699 9.99935H15.8337"
                          stroke="currentColor"
                          strokeWidth="1.67"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span>Add Member</span>
                  </button>
                  <button
                    className="btn flex justify-center items-center space-x-1"
                    onClick={() => handleClearFilter()}
                  >
                    <span className="icon-plus text-[20px] font-extrabold"></span>
                    <span>Clear Filter</span>
                  </button>
                  {/* </div>
              </div>
              <div className="flex flex-wrap gap-4 mb-6">
                <div className="flex flex-wrap items-center gap-4"> */}
                  {/* <Select
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={checkboxComponents}
                    isMulti
                    options={districts.map((item) => ({
                      value: item._id,
                      label: `${item.gujarati_name} (${item.totalUsers ?? 0})`,
                    }))}
                    value={SelectedDistrict}
                    onChange={(selected) => {
                      setSelectedDistrict(selected || []);
                      setSelectedTaluka([]);
                      setSelectedVillage([]);
                      setTalukas([]);
                      setVillages([]);
                      if (selected && selected.length) {
                        selected.forEach((opt) => fetchTalukas(opt.value));
                      }
                    }}
                    placeholder="સભ્યનો જિલ્લો"
                    classNamePrefix="react-select"
                    className="min-w-[220px] z-1001"
                    menuPortalTarget={document.body}
                    styles={menuPortalStyles}
                  />
                  <Select
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={checkboxComponents}
                    isMulti
                    options={talukas.map((item) => ({
                      value: item._id,
                      label: `${item.gujarati_name} (${item.totalUsers ?? 0})`,
                    }))}
                    value={SelectedTaluka}
                    onChange={(selected) => {
                      setSelectedTaluka(selected || []);
                      setSelectedVillage([]);
                      setVillages([]);
                      if (selected && selected.length) {
                        selected.forEach((opt) => fetchVillages(opt.value));
                      }
                    }}
                    placeholder="સભ્યના તાલુકાનું નામ"
                    classNamePrefix="react-select"
                    className="min-w-[220px]"
                    menuPortalTarget={document.body}
                    styles={menuPortalStyles}
                  />
                  <Select
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={checkboxComponents}
                    isMulti
                    options={villages.map((item) => ({
                      value: item._id,
                      label: `${item.gujarati_name} (${item.totalUsers ?? 0})`,
                    }))}
                    value={SelectedVillage}
                    onChange={(selected) => setSelectedVillage(selected || [])}
                    placeholder="સભ્યના ગામનું નામ"
                    className="min-w-[220px]"
                    menuPortalTarget={document.body}
                    styles={menuPortalStyles}
                  /> */}
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <CustomTable
            columns={columns}
            data={tableData}
            isPagination={true}
            totalRecords={paginationData}
            loading={loading}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      {isDialogOpen && (
        <AddEditCommittee
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          getCommitteeListFun={getCommitteeListFun}
          rowData={selectedRowData}
        />
      )}
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default Committee;
